<template>
    <section>

        <div class="grid">
          <div class="tilewrapper"
                v-for="(project, idx) in projects"
                :key="'project_'+idx">
            <a :href="domain + project.link" target="_blank" rel="noreferrer" @mouseover="currentId = idx" @mouseout="currentId = null"
                class="tile"
                :style="'background-image:url(' + require('../assets/images/projects/' + project.img) + ')'">
            </a>
            <th-ttip v-if="idx === currentId" :title="project.title" :info="project.info" :tags="project.tags" :offset="{x:20, y:-20}"/>
          </div>
        </div>
    </section>
</template>

<script>
import ThTtip from './ThTtip.vue';
import dataJSON from './projects.json';


export default {
  components: {
    ThTtip,
  },
  data() {
    return {
      currentId: null,
      projects: dataJSON.projects,
      domain: dataJSON.domain,
    };
  },
};
</script>

<style lang="scss">
 @import '@/assets/scss/app.scss';

.grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);

  @include breakpoint('m'){
    grid-template-columns: repeat(5, 1fr);
  }

  @include breakpoint('s'){
    grid-template-columns: repeat(4, 1fr);
  }

  @include breakpoint('xs'){
    grid-template-columns: repeat(3, 1fr);
  }

  .tilewrapper{
    width:100%;
    overflow:hidden;
    place-self: start;

    .tile{
      display: block;
      transform-origin: 50% 50%;
      transition-duration: 0.3s;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      filter: grayscale(100%);

      &:hover{
        //transform: scale(1.2);
        filter: grayscale(0%);
      }
    }

    .tile::before {
      content: "";
      display: inline-block;
      width: 1px;
      height: 0;
      padding-bottom: 100%;
    }

  }
}

// IE grid stacking fix
// Even with ms prefixes grid stacks all tiles onto each toher
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .grid {
    display: block;
  }
  .tilewrapper {
    float: left;
    width: 12.5%!important;

    @include breakpoint('m'){
      width: 20%!important;
    }

    @include breakpoint('s'){
      width: 25%!important;
    }

    @include breakpoint('xs'){
      width: 33.33%!important;
    }
  }
}
</style>
